import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
            {/* Brand */}
            <div className="lg:col-span-1">
              <Link to="/" className="text-2xl font-bold font-heading text-primary-400 whitespace-nowrap cursor-pointer">
                aaa日韩
              </Link>
              <p className="mt-3 text-sm text-foreground-400 leading-relaxed">
                aaa日韩是您探索日韩优质内容的首选平台，汇聚海量日韩正版资源，高清流畅体验，每日持续更新。
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
              <ul className="space-y-2.5">
                {[
                  { to: '/', label: '首页' },
                  { to: '/category/riju', label: '日剧' },
                  { to: '/category/handong', label: '韩剧' },
                  { to: '/category/dongman', label: '动漫' },
                  { to: '/category/zongyi', label: '综艺' },
                ].map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* More Links */}
            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">更多内容</h4>
              <ul className="space-y-2.5">
                {[
                  { to: '/category/dianying', label: '电影' },
                  { to: '/category/yinyue', label: '音乐' },
                  { to: '/about', label: '关于我们' },
                  { to: '/about', label: '联系我们' },
                  { to: '/about', label: '品牌介绍' },
                ].map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">联系方式</h4>
              <ul className="space-y-2.5">
                <li className="flex items-center gap-2 text-sm text-foreground-400">
                  <i className="ri-mail-line text-primary-400"></i>
                  <span>support@aaarihan.com</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-foreground-400">
                  <i className="ri-phone-line text-primary-400"></i>
                  <span>400-888-8888</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-foreground-400">
                  <i className="ri-time-line text-primary-400"></i>
                  <span>7×24小时在线</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="mt-12 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {currentYear} aaa日韩 版权所有 | 正版授权内容平台
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer" rel="nofollow">服务条款</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer" rel="nofollow">版权声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}